import React, { useState } from 'react';
import CurrencyInput from '../../../../../components/SafeCurrencyInput/SafeCurrencyInput.js';
import { Label, Input, FormFeedback, Table, Button } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import { formatCurrency } from '../../../../../functions/functions';
import api from "../../../../../api";

const querySelectGrupos = {
  "columns": ["pk", "nombre"],
  "table": {
    "pageSize": 99,
    "page": 0,
    "filtered": [],
    "sorted": [{ "id": "nombre", "desc": false }]
  }
}

const initialInputs = {
  grupo_nombre: null,
  grupo_id: null,
  porcentaje: 0,
  importe: 0,
  errors: {}
}

const redImportes = (accumulator, currentValue) => (accumulator + currentValue.monto);

const trunc = (n) => {
  let t = n.toString();
  let regex = /(\d*.\d{0,2})/;
  return parseFloat(t.match(regex)[0]);
}

const parsearAFloat = (m = "0") => parseFloat(String(m).replace(/[.]/g, '').replace(',', '.'));

const TableGrupos = (props) => {

  const [inputs, setInputs] = useState({...initialInputs});

  const { totalADistribuir, montosADistribuir, sumaImportesMontos, onAddToTable, onRemoveRow } = props;
  const { grupo_id, grupo_nombre, importe } = inputs;

  const setErrors = (errors) => setInputs({
    ...inputs,
    ...errors,
  });

  const onChangeInput = (field, value) => {
    setInputs({
      ...inputs,
      [field]: value,
      errors: { ...inputs.errors, [field]: undefined }
    })
  };

  const setImporte = (value) => {
    const newValue = value == null ? '' : value;
    let importeNumber = checkIsNumber(newValue);
    let max = (totalADistribuir * 100 - sumaImportesMontos * 100) / 100;
    onChangeInput('importe', importeNumber > max ? max.toFixed(2) : newValue);
  }

  // const setPorcentaje = (porcentaje) => {
  //   let newPorcentaje = porcentaje < 0.01 ? 0 : porcentaje;
  //   let newImporte = totalADistribuir * newPorcentaje / 100;
  //   // newImporte = Math.ceil(newImporte); #Ticket 6320
  //   setImporte(newImporte.toFixed(2));
  // }

  const setPorcentaje = (x) => {
    /**
     * Esta validación es para que no se ingrsen más de 2 dos decimales en el input.
     * Si bien en el input se ven sólo 2 decimales, sin esta validación, por detrás hay 3 o más.
     * Con esta valdación se aceptan hasta 2 decimales.
     * */
    let aux = x.toString()

    // Obtener la posición del punto que indica el inicio de decimales
    let pos = aux.indexOf(".")
    let count=0;
    let newImporte;
    let newPorcentaje;

    // Si no hay punto, no hay decimal por lo tanto no es necesario la validación
    if (pos!=-1){
      // Se cuenta la cantidad de digitos después del "."
      for (let i=pos+1; i<aux.length; i++){
        count=count+1;
      }
    }
    // Si la cantidad de decimales es menor a 2, se realiza el cálculo normalmente
    // Sino se tiene en cuenta el valor de la variable porcentaje
    newPorcentaje = (count <= 2) ? (x < 0.01 ? 0 : x ) : (porcentaje < 0.01 ? 0 : porcentaje)
    // if (count<=2){
    //   newPorcentaje = x < 0.01 ? 0 : x;
    //   // newImporte = Math.ceil(newImporte); #Ticket 6320
    // }else{
    //   newPorcentaje = porcentaje < 0.01 ? 0 : porcentaje;
    //   // newImporte = Math.ceil(newImporte); #Ticket 6320
    // }
    newImporte = totalADistribuir * newPorcentaje / 100;
    setImporte(newImporte.toFixed(2));
  }

  const checkIsNumber = (value) => {
    if (value == null || value === '') {
      return 0;
    }

    let toReturn = value;
    if (isNaN(value)) {
      toReturn = parsearAFloat(value);
    }
    return Number(toReturn) || 0;
  }

  // const porcentaje = (importe * 100 / totalADistribuir).toFixed(2);
  const porcentaje = (checkIsNumber(importe) * 100 / totalADistribuir).toFixed(2);

  const AddToTable = () => {
    let importeNumber = checkIsNumber(importe);
    let errors = {};
    if (grupo_id != null && porcentaje > 0 && ((importeNumber + sumaImportesMontos) <= totalADistribuir)) {
      onAddToTable({
        id: null,
        personal_id: null,
        personal_nombre: null,
        grupo_id,
        grupo_nombre,
        porcentaje: porcentaje,
        importe: importeNumber
      }, setInputs(initialInputs))
    } else {
      if (grupo_id == null) {
        errors.grupo_id = 'Seleccione un grupo'
      }
      setErrors({ errors });
    }

  }

  return (
    <section className="ui-section-block ui-section-span-2">
      <h5 className="ui-section-label">Grupos</h5>
      <div className="ui-row-action-4">
        <div>
          <Label>Grupo</Label>
          <ParadigmaAsyncSeeker
            url={api.usuarios.subgrupos.list + '?data=' + JSON.stringify(querySelectGrupos)}
            onChange={(data) => setInputs(
              {
                ...inputs, ...{ grupo_id: data ? data.pk : null, grupo_nombre: data ? data.nombre : '', errors: {} }
              })}
            value={grupo_id} />
          <FormFeedback className={(inputs.errors.grupo_id != undefined ? "d-block" : "")}>{inputs.errors.grupo_id}</FormFeedback>
        </div>

        <div>
          <Label>%</Label>
          <Input
            type="number"
            value={trunc(porcentaje)}
            onChange={(e) => setPorcentaje(e.target.value)} />
          <FormFeedback className={(inputs.errors.porcentaje != undefined ? "d-block" : "")}>{inputs.errors.porcentaje}</FormFeedback>
        </div>
        <div>
          <Label>Importe</Label>
          <CurrencyInput
            prefix={"$"}
            intlConfig={{ locale: 'es-AR', currency: 'ARS' }}
            onFocus={e => e.target.select()}
            decimalsLimit={2}
            className='form-control'
            defaultValue={0}
            groupSeparator="."
            value={importe}
            onValueChange={(value) => setImporte(value)}
          />
          <FormFeedback className={(inputs.errors.porcentaje != undefined ? "d-block" : "")}>{inputs.errors.porcentaje}</FormFeedback>
        </div>
        <Button className={"btn btn-success"} style={{ borderRadius: "8px" }} onClick={(e) => AddToTable()}>
          <i className={"fa fa-plus"}></i>
        </Button>
      </div>

      <div className="ui-row-1">
          <Table className="ui-table table-sm">
            <thead>
              <tr>
                <th width='5%'></th>
                <th width='40%'>Grupo</th>
                <th width='25%'>Porcentaje</th>
                <th width='30%'>Importe</th>
              </tr>
            </thead>
            <tbody>
              {montosADistribuir.filter((e) => e.grupo_id != null).map((data, i) =>
                <tr className="bg-light" key={`static${i}`}>
                  <td width='5%'> {data.disabled ? '' : <Button className="btn-round btn-small btn-danger mr-1" onClick={(e) => onRemoveRow(data.i)}><i className="fa fa-times"></i></Button>}</td>
                  <td width='40%'>{(data.grupo_id == null ? (data.personal_nombre) : (data.grupo_nombre))}</td>
                  <td width='25%' className={'text-right'}>
                    {trunc(data.porcentaje, 2)}
                  </td>
                  <td width='30%' className={'text-right'}>
                    {data.monto}
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan="3" className="col-1 text-right pr-4">Subtotal Grupos</th>
                <th colSpan="1" className="col-1 text-right">
                  {'$ ' + formatCurrency(trunc(montosADistribuir.filter((e) => e.grupo_id != null).reduce(redImportes, 0), 2))}
                </th>
              </tr>
            </tfoot>
          </Table>
      </div>
    </section>
  );
}

export default TableGrupos;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/ImputarModal/Tables/TableGrupos.js